import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-81245ce0")

_pushScopeId("data-v-81245ce0")
const _hoisted_1 = { class: "custom-roads" }
const _hoisted_2 = { class: "feature-table-container" }
const _hoisted_3 = {
  ref: "featureTableRef",
  style: {"height":"400px","padding-bottom":"20px"}
}
const _hoisted_4 = { class: "actions-container" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Export")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Import")
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { slot: "header" }, "Import Custom Roads", -1)
const _hoisted_10 = { slot: "content" }
const _hoisted_11 = { class: "layer" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Append Data to Custom Roads ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Overwrite Custom Roads ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Import")
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { slot: "header" }, "Export", -1)
const _hoisted_20 = { slot: "content" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "Do you want to export ?", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode("All items from the table ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Only the selected item(s) ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Export")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_calcite_button = _resolveComponent("calcite-button")
  const _component_calcite_radio_button = _resolveComponent("calcite-radio-button")
  const _component_calcite_label = _resolveComponent("calcite-label")
  const _component_calcite_radio_button_group = _resolveComponent("calcite-radio-button-group")
  const _component_calcite_modal = _resolveComponent("calcite-modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, null, 512)
    ]),
    _createVNode("div", _hoisted_4, [
      (_ctx.isEditor && _ctx.tableSize.size > 0)
        ? (_openBlock(), _createBlock(_component_calcite_button, {
            key: 0,
            "icon-end": "trash",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.onRemoveCustomRoad())),
            color: "red",
            style: {"margin-right":"10px"},
            disabled: _ctx.tableSelectedItems.size == 0
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (_ctx.isEditor)
        ? (_openBlock(), _createBlock(_component_calcite_button, {
            key: 1,
            "icon-end": "plus",
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.onNewCustomRoad())),
            style: {"margin-right":"10px"}
          }, {
            default: _withId(() => [
              _hoisted_6
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isEditor)
        ? (_openBlock(), _createBlock(_component_calcite_button, {
            key: 2,
            "icon-end": "export",
            onClick: _cache[3] || (_cache[3] = $event => (_ctx.showExportModal())),
            style: {"margin-right":"10px"},
            disabled: _ctx.tableSize.size == 0
          }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (_ctx.isEditor)
        ? (_openBlock(), _createBlock(_component_calcite_button, {
            key: 3,
            "icon-end": "import",
            onClick: _cache[4] || (_cache[4] = $event => (_ctx.showImportModal()))
          }, {
            default: _withId(() => [
              _hoisted_8
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_calcite_modal, {
      width: "m",
      active: "false",
      "disable-close-button": "",
      "disable-outside-close": "",
      ref: "importModal"
    }, {
      default: _withId(() => [
        _hoisted_9,
        _createVNode("div", _hoisted_10, [
          (!_ctx.showFT)
            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.allLayers, (layer) => {
                return (_openBlock(), _createBlock("div", _hoisted_11, [
                  (layer.geometryType === 'polyline' && layer.title != 'Published Roads')
                    ? (_openBlock(), _createBlock("div", _hoisted_12, [
                        _createVNode(_component_calcite_button, {
                          appearance: "transparent",
                          onClick: $event => {_ctx.showFT = true; _ctx.showFeatureTable(layer)}
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(layer.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 256))
            : _createCommentVNode("", true),
          _createVNode("div", {
            ref: "featureTableRef2",
            class: {'feature-table' : _ctx.showFT}
          }, null, 2),
          (_ctx.showFT)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode(_component_calcite_radio_button_group, { style: {"margin-left":"15px"} }, {
                  default: _withId(() => [
                    _createVNode(_component_calcite_label, { layout: "inline" }, {
                      default: _withId(() => [
                        _createVNode(_component_calcite_radio_button, {
                          onClick: _cache[5] || (_cache[5] = $event => {_ctx.appendData = !_ctx.appendData; _ctx.overwriteData = !_ctx.overwriteData}),
                          checked: ""
                        }),
                        _hoisted_14
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_calcite_label, { layout: "inline" }, {
                      default: _withId(() => [
                        _createVNode(_component_calcite_radio_button, {
                          onClick: _cache[6] || (_cache[6] = $event => {_ctx.overwriteData = !_ctx.overwriteData; _ctx.appendData = !_ctx.appendData})
                        }),
                        _hoisted_15
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.showFT)
          ? (_openBlock(), _createBlock(_component_calcite_button, {
              key: 0,
              slot: "back",
              color: "light",
              onClick: _cache[7] || (_cache[7] = $event => {_ctx.showFT = false; _ctx.hideImportModal(); _ctx.size = 0})
            }, {
              default: _withId(() => [
                _hoisted_16
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showFT)
          ? (_openBlock(), _createBlock(_component_calcite_button, {
              key: 1,
              slot: "back",
              color: "light",
              onClick: _cache[8] || (_cache[8] = $event => {_ctx.showFT = false; _ctx.hideFeatureTable()})
            }, {
              default: _withId(() => [
                _hoisted_17
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_calcite_button, {
          slot: "primary",
          color: "blue",
          onClick: _cache[9] || (_cache[9] = $event => {_ctx.showFT = false; _ctx.hideFeatureTable(); _ctx.hideImportModal(); _ctx.importData();}),
          class: {'clickable' : _ctx.isDisable}
        }, {
          default: _withId(() => [
            _hoisted_18
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_calcite_modal, {
      width: "m",
      active: "false",
      "disable-close-button": "",
      "disable-outside-close": "",
      ref: "exportModal"
    }, {
      default: _withId(() => [
        _hoisted_19,
        _createVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode(_component_calcite_radio_button_group, { style: {"margin-left":"25%","margin-top":"1%"} }, {
            default: _withId(() => [
              _createVNode(_component_calcite_label, { layout: "inline" }, {
                default: _withId(() => [
                  _createVNode(_component_calcite_radio_button, {
                    onClick: _cache[10] || (_cache[10] = $event => (_ctx.exportType = 'Layer')),
                    checked: ""
                  }),
                  _hoisted_22
                ]),
                _: 1
              }),
              _createVNode(_component_calcite_label, { layout: "inline" }, {
                default: _withId(() => [
                  _createVNode(_component_calcite_radio_button, {
                    onClick: _cache[11] || (_cache[11] = $event => (_ctx.exportType = 'Selected'))
                  }),
                  _hoisted_23
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_calcite_button, {
          slot: "back",
          color: "light",
          onClick: _cache[12] || (_cache[12] = $event => (_ctx.hideExportModal())),
          title: "Close the modal"
        }, {
          default: _withId(() => [
            _hoisted_24
          ]),
          _: 1
        }),
        _createVNode(_component_calcite_button, {
          slot: "primary",
          color: "blue",
          onClick: _cache[13] || (_cache[13] = $event => {_ctx.hideExportModal(); _ctx.exportData()}),
          title: "Export and download data"
        }, {
          default: _withId(() => [
            _hoisted_25
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ]))
})